import { Filter, IsFilterable } from "@/lib/filterable";
import { AccidentDetails, IAccidentDetails } from "./accident-details.entity";
import { IReport } from "./report.entity";
import { TripTypeEnum } from "@/lib/enum/trip-type.enum";

@IsFilterable
class AccidentBase {
  _report?: Partial<IReport> = undefined;

  details?: IAccidentDetails | null = null;
  isUnderInfluence?: boolean | null = null;
  tripType?: TripTypeEnum | null = null;
  isValidDriversLicense?: boolean | null = null;

  constructor(obj?: Partial<IReport>) {
    this._report = obj;
    this.details = new AccidentDetails(obj?.accidentDetails);
    this.isUnderInfluence = obj?.isUnderInfluence;
    this.isValidDriversLicense = obj?.isValidDriversLicense;
    this.tripType = obj?.tripType;
  }

  setReport(report: IReport) {
    this._report = report;
  }

  async update() {
    if (!this._report?.id) {
      return;
    }

    const report = this._report as IReport;

    await report.updatePartial({
      isUnderInfluence: this.isUnderInfluence,
      tripType: this.tripType,
      isValidDriversLicense: this.isValidDriversLicense,
      accidentDetails: this.details
    });
  }
}

type IAccident = AccidentBase;
const Accident = Filter.createForClass(AccidentBase);

export { Accident, IAccident };
